import { isValidDocumentNumber, OnboardingDetailsRole, Relation } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import {
  phoneValidation,
  requiredDialCode,
  requiredEmail,
  requiredEnum,
  requiredPhoneNumber,
  requiredString,
} from '@/utils/zodUtils';

export const AddParticipantToLoanSchema = (t: GetTextIdTranslationType) => {
  return z
    .object({
      participantRole: requiredEnum(OnboardingDetailsRole, t),
      invitationFirstName: requiredString(t),
      invitationLastName: requiredString(t),
      dialCode: requiredDialCode(t),
      phoneNumber: requiredPhoneNumber(t),
      invitationEmail: requiredEmail(t),
      invitationRelation: requiredEnum(Relation, t),
      invitationDocumentNumber: z.string().optional(),
    })
    .refine((data) => !(data.phoneNumber && data.dialCode && !phoneValidation(data)), {
      message: t('INVALID_PHONE_NUMBER'),
      path: ['phoneNumber'],
    })
    .refine((data) => !(data.invitationDocumentNumber && !isValidDocumentNumber(data.invitationDocumentNumber)), {
      message: t('INVALID_DOCUMENT_NUMBER'),
      path: ['invitationDocumentNumber'],
    });
};

export type AddParticipantToLoanType = z.infer<ReturnType<typeof AddParticipantToLoanSchema>>;
